const zIndexes = {
  tableHeader: 1,
  tableStickyColumn: 2,
  widgetDropdownOptions: 4,
  widgetDropdownHeader: 5,
  /** @deprecated dropdown options are now using same zindex as modal */
  dropdownOptions: 10,
  actionSheet: 11,
  loader: 12,
  overlay: 200,
  modal: 250,
  tooltip: 300,
} as const;

export default zIndexes;
